let title = ' | Gestor - Comercial Ivaiporã'

const gestaoFrota = {
    path: '/gestao-frota',
    component: () => import('@/Components/GestaoFrota/GestaoFrotaContainer.vue'),
    children: [
        {
            path: '',
            redirect: 'dashboard'
        },

        // Análises
        {
            path: 'dashboard',
            name: 'DashboardLogistica2',
            component: () => import('@/Components/GestaoFrota/Analises/Dashboard.vue'),
            meta: {
                title: 'Gestao de Frota' + title,
                permission: 'logistica_menu_gestao_frota',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Gestão de Frota',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/filial',
                    }
                ]
            }
        },

        // RELATÓRIOS COM CHILDREN ANINHADOS
        {
            path: 'relatorios',
            name: 'RelatoriosLogistica',
            component: () => import('@/Components/GestaoFrota/Analises/Relatorios.vue'),
            meta: {
                title: 'Relatórios' + title,
                permission: 'logistica_menu_gestao_frota',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Gestão de Frota',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/filial',
                    }
                ]
            },
            // children: [
            //     {
            //         path: 'rel_101',
            //         name: 'RelatoriosIndex',
            //         component: () => import('@/Components/GestaoFrota/Analises/Relatorios/Rel_101.vue'),
            //         meta: {
            //             title: 'Relatórios - Visão Geral' + title,
            //             permission: 'logistica_menu_gestao_frota',
            //         }
            //     },
                // {
                //     path: 'rel_102',
                //     name: 'RelatoriosVeiculos',
                //     component: () => import('@/Components/GestaoFrota/Relatorios/Veiculos.vue'),
                //     meta: {
                //         title: 'Relatórios - Veículos' + title,
                //         permission: 'logistica_menu_gestao_frota',
                //     }
                // },
                // {
                //     path: 'rel_103',
                //     name: 'RelatoriosCombustivel',
                //     component: () => import('@/Components/GestaoFrota/Relatorios/Combustivel.vue'),
                //     meta: {
                //         title: 'Relatórios - Combustível' + title,
                //         permission: 'logistica_menu_gestao_frota',
                //     }
                // },
            // ]
        },

        // Cadastros
        {
            path: 'cadastros/veiculos',
            name: 'cadastros-veiculos',
            component: () => import('@/Components/GestaoFrota/Cadastros/Veiculos.vue'),
            meta: {
                title: 'Veículos' + title,
                permission: 'logistica_menu_gestao_frota',
            }
        },
        {
            path: 'cadastros/veiculos/novo',
            name: 'cadastros-veiculos-novo',
            component: () => import('@/Components/GestaoFrota/Cadastros/VeiculosLancar.vue'),
            meta: {
                title: 'Veículos' + title,
                permission: 'logistica_menu_gestao_frota',
            }
        },

        // Financeiro - Despesas
        {
            path: 'financeiro/abastecimentos/despesas',
            name: 'financeiro-abastecimentos-despesas',
            component: () => import('@/Components/GestaoFrota/Financeiro/AbastecimentosDespesas.vue'),
            meta: {
                title: 'Despesas' + title,
                permission: 'logistica_menu_gestao_frota',
            }
        },
        {
            path: 'financeiro/abastecimentos/despesas/novo',
            name: 'financeiro-abastecimentos-despesas-novo',
            component: () => import('@/Components/GestaoFrota/Financeiro/AbastecimentosDespesasLancar.vue'),
            meta: {
                title: 'Despesas' + title,
                permission: 'logistica_menu_gestao_frota',
            }
        },

        // Financeiro - Requisições
        {
            path: 'financeiro/abastecimentos/requisicoes',
            name: 'financeiro-abastecimentos-requisicoes',
            component: () => import('@/Components/GestaoFrota/Financeiro/AbastecimentosRequisicoes.vue'),
            meta: {
                title: 'Requisicoes' + title,
                permission: 'logistica_menu_gestao_frota',
            }
        },
        {
            path: 'financeiro/abastecimentos/requisicoes/novo',
            name: 'financeiro-abastecimentos-requisicoes-novo',
            component: () => import('@/Components/GestaoFrota/Financeiro/AbastecimentosRequisicoesLancar.vue'),
            meta: {
                title: 'Requisicoes' + title,
                permission: 'logistica_menu_gestao_frota',
            }
        },
    ]
}

export default gestaoFrota